import { Container } from './styles';
import { Props, Group } from './types';
import React, { Dispatch, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Action } from 'typesafe-actions';
import { ApplicationState } from '../../store';
import Filter from './componenents/Filter';
import { useWindowSize } from '../../hook/useWindowSize';
import moment from 'moment';
import TitlePage from '../../components/TitlePage';
import AnchorButton from '../../components/AnchorButton';
import { HandleClickRowActive } from '../../utils/handleclickrowactive';
import { loadRequest } from '../../store/ducks/tracking/actions';
import TableSort from '../../components/TableSort';
import GetStatus from '../../components/GetStatus';
import ExpandedRowRender from './componenents/ExpandedRowRender';
import ModalNota from './componenents/ModalNota';
import { Button, Dropdown, Menu, notification, Tooltip } from 'antd';
import {
  EllipsisOutlined,
  DownloadOutlined,
  SmileOutlined,
  FilterOutlined,
} from '@ant-design/icons';
import api from '../../service/api';
import { SKW_PREFIX } from '../../utils/constants';
import saveAs from 'file-saver';
import Mobile from './Mobile';
import Localizacao from './componenents/ModalLocalizacao';
import mask from '../../utils/mask';
import TextTable from '../../components/TextTable';
import Refresh from '../../components/Refresh';
import { TrackingList } from './services/listaDepositantesTracking';
import { dadosFormatados } from './utils/formataTabela';
import { ExportBtn } from 'components/_REFACTORED/ExportBtn';
import { ContFilter } from 'modules/atendimento/style';

const Tracking: React.FC<Props> = () => {
  const dispatch = useDispatch<Dispatch<Action>>();
  const { width }: any = useWindowSize();
  const cdd = useSelector((state: ApplicationState) => state.auth?.cddAtivo?.codCdd) as
    | number
    | undefined;
  const inscricoesAtivas = useSelector((state: ApplicationState) => state.auth.inscricaoAtiva);
  const pagination = useSelector((state: ApplicationState) => state.Tracking.pagination);
  const loading = useSelector((state: ApplicationState) => state.Tracking.loading);
  const data = useSelector((state: ApplicationState) => state.Tracking.data);
  const token = useSelector((state: ApplicationState) => state.auth.token);
  const filter = useSelector((state: ApplicationState) => state.Tracking.filter);
  const [filterActive, setFilterActive] = useState<string[]>([]);

  useEffect(() => {
    if (filter)
      Object.keys(filter as {}).forEach((key) => {
        if (filter[key] === undefined || filter[key] === null || filter[key] === '') {
          delete filter[key];
        }
      });
    setFilterActive(Object.keys(filter ?? {}));
  }, [filter]);

  const openNotification = (message: string) => {
    notification.open({
      message: message,
      description: '',
      icon: <SmileOutlined style={{ color: '#108ee9' }} />,
      placement: 'bottomRight',
    });
  };

  const handleDownload = (record: any) => {
    if (record?.qtdAnexo > 0)
      api
        .post(
          `call?serviceName=${SKW_PREFIX}BaixarCanhoto&token=${token}`,
          {
            cteNunota: record?.cteNunota,
          },
          {
            responseType: 'blob',
          }
        )
        .then((res) => {
          const blob = new Blob([res.data], { type: 'application/octet-stream' });
          saveAs(blob, 'canhoto.zip');
        })
        .catch((err) => {
          openNotification(
            'Não foi possível baixar o canhoto, verifique se o mesmo já foi anexado.'
          );
        });
    else
      openNotification('Não foi possível baixar o canhoto, verifique se o mesmo já foi anexado.');
  };

  const getData = async () => {
    const { data } = await TrackingList.getAllData(cdd, filter, inscricoesAtivas, pagination.total);

    return dadosFormatados(data.Tracking);
  };

  const dataExport = dadosFormatados(data);

  const columns: Group[] = [
    {
      key: 'cteNunota',
      title: 'Número do CT-e',
      dataIndex: 'cteNunota',
      align: 'center',
      render: (text: string) => {
        return text ? <TextTable>{text}</TextTable> : <TextTable>Não informado</TextTable>;
      },
    },
    {
      key: 'nfNumNota',
      title: 'Número da NF',
      dataIndex: 'nfNumNota',
      align: 'center',
      render: (text: any, record: any) => {
        return text ? <ModalNota record={record} /> : <TextTable>Não informado</TextTable>;
      },
    },
    {
      key: 'status',
      title: 'Status',
      dataIndex: 'status',
      align: 'center',
      width: 300,
      render: (text: string) => {
        return text ? <GetStatus acronym={text} /> : <TextTable>Não informado</TextTable>;
      },
    },
    {
      key: 'destinatario',
      title: 'Cliente',
      dataIndex: 'destinatario',
      align: 'center',
      render: (text: string) => {
        return text ? (
          <TextTable>{mask('camelCase', text)}</TextTable>
        ) : (
          <TextTable>Não informado</TextTable>
        );
      },
    },
    {
      key: 'placa',
      title: 'Veículo',
      dataIndex: 'placa',
      align: 'center',
      render: (text: string, record: any) => {
        return text ? (
          <TextTable>{text?.toUpperCase()}</TextTable>
        ) : (
          <TextTable>Não informada</TextTable>
        );
      },
    },
    {
      key: 'dtSaida',
      title: 'Data de embarque',
      dataIndex: 'dtSaida',
      align: 'center',
      render: (text: string) => {
        return text ? (
          <TextTable>{moment(text).format('LL')}</TextTable>
        ) : (
          <TextTable>Não informada</TextTable>
        );
      },
    },
    {
      key: 'cidadeOrigem',
      title: 'Cidade origem',
      dataIndex: 'cidadeOrigem',
      align: 'center',
      render: (text: string) => {
        return text ? (
          <TextTable>{mask('camelCase', text)}</TextTable>
        ) : (
          <TextTable>Não informada</TextTable>
        );
      },
    },
    {
      key: 'cidadeDestino',
      title: 'Cidade destino',
      dataIndex: 'cidadeDestino',
      align: 'center',
      render: (text: string) => {
        return text ? (
          <TextTable>{mask('camelCase', text)}</TextTable>
        ) : (
          <TextTable>Não informada</TextTable>
        );
      },
    },
    {
      key: 'dtPrevChegada',
      title: 'Previsão de entrega',
      dataIndex: 'dtPrevChegada',
      align: 'center',
      render: (text: string) => {
        return text ? (
          <TextTable>{moment(text).format('LL')}</TextTable>
        ) : (
          <TextTable>Não informada</TextTable>
        );
      },
    },
    {
      key: 'dtPrazoAcordado',
      title: 'Prazo acordado',
      dataIndex: 'dtPrazoAcordado',
      align: 'center',
      render: (text: string) => {
        return text ? (
          <TextTable>{moment(text).format('LL')}</TextTable>
        ) : (
          <TextTable>Não informada</TextTable>
        );
      },
    },
    {
      title: 'Ação',
      dataIndex: 'acao',
      key: 'acao',
      width: 100,
      fixed: 'right',
      render: (text: any, record: any) => {
        const menuDropDown = (
          <Menu>
            <Menu.Item>
              <Tooltip title={record?.qtdAnexo === 0 ? 'Não há canhoto' : ''}>
                <Button
                  icon={<DownloadOutlined />}
                  onClick={() => handleDownload(record)}
                  disabled={record?.qtdAnexo === 0 ? true : false}
                >
                  Baixar canhoto
                </Button>
              </Tooltip>
            </Menu.Item>

            <Menu.Item>
              <Tooltip title="Ver a localização do veículo">
                <Localizacao record={record} />
              </Tooltip>
            </Menu.Item>
          </Menu>
        );
        return (
          <Dropdown overlay={menuDropDown}>
            <Button type="text" className="ant-dropdown-link" onClick={(e) => e.preventDefault()}>
              <EllipsisOutlined
                style={{ fontSize: '30px', transform: 'rotate(90deg)', color: '#3c6ab4' }}
              />
            </Button>
          </Dropdown>
        );
      },
    },
  ];

  return (
    <>
      <Refresh
        loadRequest={() =>
          dispatch(loadRequest(filter, inscricoesAtivas, cdd as number, pagination))
        }
      />
      <Filter />

      <Container>
        <TitlePage>
          <span>
            <AnchorButton textRoute={'tracking'} />
            Tracking
          </span>
          {filterActive.length > 0 && (
            <ContFilter>
              {filterActive.map((item) => (
                <p key={item}>
                  {item === 'numNota' && (
                    <>
                      <FilterOutlined /> Nº da NF
                    </>
                  )}
                  {item === 'cidadeDestino' && (
                    <>
                      <FilterOutlined />
                      Cidade destinatário
                    </>
                  )}

                  {item === 'destinatario' && (
                    <>
                      <FilterOutlined />
                      Cliente destinatário
                    </>
                  )}

                  {item === 'status' && (
                    <>
                      <FilterOutlined />
                      Status
                    </>
                  )}
                </p>
              ))}
            </ContFilter>
          )}
          <div className="box">
            <ExportBtn onGetAllData={getData} screenData={dataExport} filename={'tracking'} />
          </div>
        </TitlePage>

        {width > 768 && (
          <TableSort
            dataSource={data}
            columns={columns}
            pagination={pagination}
            loading={loading}
            className="table"
            rowKey={'seq'}
            size={'large'}
            scroll={{ x: 2000 }}
            onRow={(record: any, rowIndex: any) => {
              return {
                onClick: (event: React.MouseEvent<HTMLElement>) =>
                  HandleClickRowActive(event, record),
              };
            }}
            onChange={(pagination: any, filters: any, sorter: any) => {
              dispatch(loadRequest(filter, inscricoesAtivas, cdd as number, pagination));
            }}
            expandable={{
              expandedRowRender: (record: any) => (
                <>
                  <ExpandedRowRender record={record} />
                </>
              ),
            }}
            style={{ fontSize: 10, display: 'inline' }}
          />
        )}
        {width <= 768 && <Mobile handleDownload={handleDownload} filter={filter} />}
      </Container>
    </>
  );
};

export default Tracking;
